import { encodeDocument } from "../FlowDocument/DocumentEncode";
import { convertToDocument } from "../FlowDocument/DocumentProcessor";
import { ReactFlowInstance } from "reactflow";

export const download = (isExperimental: boolean, flowInputController: any, reactFlowInstance: ReactFlowInstance) => {
  const flowDocument = convertToDocument(isExperimental, flowInputController?.flowInputPool, reactFlowInstance);

  encodeDocument(flowDocument).then((encodedDocument: string) => {
    downloadJson(encodedDocument, document.title + ".txt");
  });
};

const downloadJson = (json: string, title: string) => {
  var file = new Blob([json], { type: "txt" });
  var a = document.createElement("a"),
    url = URL.createObjectURL(file);
  a.href = url;
  a.download = title;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
};
